module.exports = __webpack_public_path__ + "static/person-bubble-3-f98a180d5fc0b3c49dffd9fc93199440.png";